

if($('.product, .type-detail').length){
    file = "/user/documents/prepocet.txt?v="+new Date().getMinutes()
    $(document).ready(function() {
        var productData = sessionStorage.getItem('myProductData');
        if (!productData) {
            $.get(file, function(data) {
                var storageData = {};
                lines = data.split('\n');
                for (var i = 0; i < lines.length; i++) {
                    var radek = lines[i];
                    var spl = radek.split(';');
                    var productCode = spl[0];
                    var productprepocet = spl[1];
                    var productMeasureUnit = spl[2];
                    storageData[productCode] = {
                        productprepocet: productprepocet,
                        productMeasureUnit: productMeasureUnit
                    };
                }
              //  console.log(storageData)
                sessionStorage.setItem('myProductData', JSON.stringify(storageData));
                $('.product:not(.lastest-wiev)').each(function() {
                    var find_code = $(this).find('span[data-micro="sku"]').text().trim();
                    var storedData = JSON.parse(sessionStorage.getItem('myProductData'))[find_code];
                    $(this).find(".prices").prependTo($(this).find(".p-tools"));
                    $(this).find(".flag-discount").html(function(i, v) {
                        return v.replace("od", "");
                    });
                    var find_code = $(this).find('span[data-micro="sku"]').text().trim();
                    var storedData = JSON.parse(sessionStorage.getItem('myProductData'))[find_code];
                    if (storedData) {
                        var newPrice = ''
                            if($(this).find('.flag-discount').length){
                                newPrice += '<span class="price-save">'+$(this).find('a.image .flag-discount .price-save').text()+'</span>'
                                newPrice += '<span class="price-standard"><span>'+Number(Math.round(parseFloat($(this).find('.flag-discount .price-standard').text().replace(',', '.').replace(/ /g, ''))*storedData.productprepocet)).ShoptetFormatAsCurrency()+'</span></span>'
                            }       
                            newPrice += '<div class="price price-final" data-testid="productCardPrice">'   
                                newPrice += '<strong>'+Number(Math.round(parseFloat($(this).find('.prices .price.price-final strong').text().replace(',', '.').replace(/ /g, ''))*storedData.productprepocet)).ShoptetFormatAsCurrency()+'</strong>'
                                newPrice += '<span class="pr-list-unit">/ '+storedData.productMeasureUnit+'</span>'
                            newPrice += '</div>'
                        $(this).find('.p-bottom>div .prices').html(newPrice)
                       
                    }
                    else{
                        if($(this).find('a.image .flag-discount').length){
                            $(this).find(".flag.flag-discount .price-standard").insertBefore($(this).find(".price.price-final")).parent().addClass("discount");
                            var findPrices = $(this).find('.prices')
                            $(this).find('a.image .flag-discount .price-save').clone().appendTo(findPrices)
                        }
                    }
                });

                document.addEventListener('ShoptetDOMContentLoaded', function() {
                    $('.product:not(.lastest-wiev)').each(function() {
                        var find_code = $(this).find('span[data-micro="sku"]').text().trim();
                        var storedData = JSON.parse(sessionStorage.getItem('myProductData'))[find_code];
                        $(this).find(".prices").prependTo($(this).find(".p-tools"));
                        $(this).find(".flag-discount").html(function(i, v) {
                            return v.replace("od", "");
                        });
                        var find_code = $(this).find('span[data-micro="sku"]').text().trim();
                        var storedData = JSON.parse(sessionStorage.getItem('myProductData'))[find_code];
                        if (storedData) {
                            var newPrice = ''
                                if($(this).find('.flag-discount').length){
                                    newPrice += '<span class="price-save">'+$(this).find('a.image .flag-discount .price-save').text()+'</span>'
                                    newPrice += '<span class="price-standard"><span>'+Number(Math.round(parseFloat($(this).find('.flag-discount .price-standard').text().replace(',', '.').replace(/ /g, ''))*storedData.productprepocet)).ShoptetFormatAsCurrency()+'</span></span>'
                                }       
                                newPrice += '<div class="price price-final" data-testid="productCardPrice">'   
                                    newPrice += '<strong>'+Number(Math.round(parseFloat($(this).find('.prices .price.price-final strong').text().replace(',', '.').replace(/ /g, ''))*storedData.productprepocet)).ShoptetFormatAsCurrency()+'</strong>'
                                    newPrice += '<span class="pr-list-unit">/ '+storedData.productMeasureUnit+'</span>'
                                newPrice += '</div>'
                            $(this).find('.p-bottom>div .prices').html(newPrice)
                           
                        }
                        else{
                            if($(this).find('a.image .flag-discount').length){
                                $(this).find(".flag.flag-discount .price-standard").insertBefore($(this).find(".price.price-final")).parent().addClass("discount");
                                var findPrices = $(this).find('.prices')
                                $(this).find('a.image .flag-discount .price-save').clone().appendTo(findPrices)
                            }
                        }
                    });
                });

            });
        } else {
            $('.product:not(.lastest-wiev)').each(function() {
                var find_code = $(this).find('span[data-micro="sku"]').text().trim();
                var storedData = JSON.parse(sessionStorage.getItem('myProductData'))[find_code];
                $(this).find(".prices").prependTo($(this).find(".p-tools"));
                $(this).find(".flag-discount").html(function(i, v) {
                    return v.replace("od", "");
                });
                if (storedData) {
                    var newPrice = ''
                        if($(this).find('.flag-discount').length){
                            newPrice += '<span class="price-save">'+$(this).find('a.image .flag-discount .price-save').text()+'</span>'
                            newPrice += '<span class="price-standard"><span>'+Number(Math.round(parseFloat($(this).find('.flag-discount .price-standard').text().replace(',', '.').replace(/ /g, ''))*storedData.productprepocet)).ShoptetFormatAsCurrency()+'</span></span>'
                        }       
                        newPrice += '<div class="price price-final" data-testid="productCardPrice">'   
                            newPrice += '<strong>'+Number(Math.round(parseFloat($(this).find('.prices .price.price-final strong').text().replace(',', '.').replace(/ /g, ''))*storedData.productprepocet)).ShoptetFormatAsCurrency()+'</strong>'
                            newPrice += '<span class="pr-list-unit">/ '+storedData.productMeasureUnit+'</span>'
                        newPrice += '</div>'
                    $(this).find('.p-bottom>div .prices').html(newPrice)
                   
                }
                else{
                    if($(this).find('a.image .flag-discount').length){
                        $(this).find(".flag.flag-discount .price-standard").insertBefore($(this).find(".price.price-final")).parent().addClass("discount");
                        var findPrices = $(this).find('.prices')
                        $(this).find('a.image .flag-discount .price-save').clone().appendTo(findPrices)
                    }
                }
            });

            document.addEventListener('ShoptetDOMContentLoaded', function() {
                $('.product:not(.lastest-wiev)').each(function() {
                    var find_code = $(this).find('span[data-micro="sku"]').text().trim();
                    var storedData = JSON.parse(sessionStorage.getItem('myProductData'))[find_code];
                    $(this).find(".prices").prependTo($(this).find(".p-tools"));
                    $(this).find(".flag-discount").html(function(i, v) {
                        return v.replace("od", "");
                    });
                    if (storedData) {
                        var newPrice = ''
                            if($(this).find('.flag-discount').length){
                                newPrice += '<span class="price-save">'+$(this).find('a.image .flag-discount .price-save').text()+'</span>'
                                newPrice += '<span class="price-standard"><span>'+Number(Math.round(parseFloat($(this).find('.flag-discount .price-standard').text().replace(',', '.').replace(/ /g, ''))*storedData.productprepocet)).ShoptetFormatAsCurrency()+'</span></span>'
                            }       
                            newPrice += '<div class="price price-final" data-testid="productCardPrice">'   
                                newPrice += '<strong>'+Number(Math.round(parseFloat($(this).find('.prices .price.price-final strong').text().replace(',', '.').replace(/ /g, ''))*storedData.productprepocet)).ShoptetFormatAsCurrency()+'</strong>'
                                newPrice += '<span class="pr-list-unit">/ '+storedData.productMeasureUnit+'</span>'
                            newPrice += '</div>'
                        $(this).find('.p-bottom>div .prices').html(newPrice)
                       
                    }
                    else{
                        if($(this).find('a.image .flag-discount').length){
                            $(this).find(".flag.flag-discount .price-standard").insertBefore($(this).find(".price.price-final")).parent().addClass("discount");
                            var findPrices = $(this).find('.prices')
                            $(this).find('a.image .flag-discount .price-save').clone().appendTo(findPrices)
                        }
                    }
                });
            })
        }
    });    

   

    $('#productsTop .product').each(function(){
        $(this).find('.p-bottom>div').append('<a href="'+$(this).find('a.name').attr('href')+'" class="btn btn-primary">Detail</a>')
    })
}

